(function ($) {
  "use strict";
  $("#hamburguer-mobile").on("click", function (e) {
    e.preventDefault();
    $("#menu-mobile").addClass("is-active");
    $("html, body").css("overflow", "hidden");
  });

  $("#menu-mobile .close-button").on("click", function () {
    $("#menu-mobile").removeClass("is-active");
    $("html, body").css("overflow-y", "auto");
  });

  $("#main-nav .menu-item.dropdown").on("click", function () {
    $(this).toggleClass("is-active");
  });

})(jQuery);